import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import { Login } from './pages/Login'
import { Dashboard } from './pages/Dashboard'
import { Files } from './pages/Files'
import { Projects } from './pages/Projects'
import { Apps } from './pages/Apps'
import { Admin } from './pages/Admin'
import { People } from './pages/People'
import { MyWork } from './pages/MyWork'
import { Services } from './pages/Services'
import { Layout } from './components/Layout'
import { AppWrapper } from './pages/AppWrapper'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-[var(--color-text-secondary)]">Loading...</div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth()

  if (user?.role !== 'admin' && user?.role !== 'partner') {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* App wrapper — full viewport, outside Layout */}
      <Route
        path="/apps/:accessId/run"
        element={
          <ProtectedRoute>
            <AppWrapper />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="files" element={<Files />} />
        <Route path="files/*" element={<Files />} />
        <Route path="projects" element={<Projects />} />
        <Route path="projects/:projectId" element={<Projects />} />
        <Route path="apps" element={<Apps />} />
        <Route path="services" element={<Services />} />
        <Route path="my-work" element={<MyWork />} />
        <Route
          path="people"
          element={
            <AdminRoute>
              <People />
            </AdminRoute>
          }
        />
        <Route
          path="people/:personId"
          element={
            <AdminRoute>
              <People />
            </AdminRoute>
          }
        />
        <Route
          path="admin"
          element={
            <AdminRoute>
              <Admin />
            </AdminRoute>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
